import { PurchaseRequestItemType } from "../../../types";
import type { ItemRow } from "./types";

/**
 * The fields an item still needs before the request can be submitted.
 *
 * Single source of truth: the compact row's status chip, the header's summary
 * line and the submit gate all derive from this, so they can never disagree
 * (the previous implementation had three separate copies of these rules).
 */
export type MissingField =
  | "material"
  | "quantity"
  | "deliveryPlace"
  | "dates"
  | "purpose";

export const missingFields = (item: ItemRow): MissingField[] => {
  const missing: MissingField[] = [];
  if (!item.material?.id) missing.push("material");
  if (item.quantity == null || item.quantity <= 0) missing.push("quantity");

  const hasSite = !!item.site?.id;
  const hasAddress = !!item.address && item.address.trim() !== "";
  if (!hasSite && !hasAddress) missing.push("deliveryPlace");

  // Required per product direction. With "apply to all items" on, filling the
  // single date in the options panel satisfies every row at once.
  if (!item.neededFrom) missing.push("dates");

  if (item.itemType === PurchaseRequestItemType.SERVICE) {
    if (!item.purpose || !item.purpose.trim()) missing.push("purpose");
  }
  return missing;
};

export const isItemComplete = (item: ItemRow): boolean =>
  missingFields(item).length === 0;
